var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSection2Icon4 = function SvgSection2Icon4(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 10,
    fill: "#F9F6FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.17 9 23 13.83V23H9V9h9.17Zm0-2H9c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-9.17c0-.53-.21-1.04-.59-1.41l-4.83-4.83c-.37-.38-.88-.59-1.41-.59ZM11 19h10v2H11v-2Zm0-4h10v2H11v-2Zm0-4h7v2h-7v-2Z",
    fill: "#6400FF"
  })));
};
export default SvgSection2Icon4;